// This file was generated by https://github.com/redbubble/design/blob/master/scripts/generateIcons.js
import React from 'react';
import Icon from '../Icon';

const SocialFlickrIcon = props => <Icon {...props} dangerouslySetIcon={'<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M20.25 3H3.75C3.3 3 3 3.3 3 3.75v16.5c0 .45.3.75.75.75h16.5c.45 0 .75-.3.75-.75V3.75c0-.45-.3-.75-.75-.75zm-12 12c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3zm7.5 0c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3z" fill="currentColor"/></svg>'} />;

SocialFlickrIcon.displayName = 'SocialFlickrIcon';

export default SocialFlickrIcon;
